import { useCallback, useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { updateLanguage } from 'shared/api/user/requests/updateLanguage'
import { i18nextContainer } from 'shared/configs/i18n/config'

import { ProfileMenuRow } from '../ProfileMenuRow/ProfileMenuRow'
import styles from './LanguageSection.module.scss'
import {
  LANGUAGE_DROPDOWN_OPTIONS,
  getLanguageContextMenuOptions
} from './LanguageSection.utils'

const LanguageSection = () => {
  const { t, i18n } = useTranslation()

  const currentLanguage = useMemo(() => {
    const currentLang = i18n.language || 'en'
    return (
      LANGUAGE_DROPDOWN_OPTIONS.find(option =>
        currentLang.startsWith(option.value)
      ) || LANGUAGE_DROPDOWN_OPTIONS[0]
    )
  }, [i18n.language])

  const onLanguageChange = useCallback(async (langValue: string) => {
    i18nextContainer.changeLanguage(langValue)
    try {
      await updateLanguage(langValue)
    } catch {
      // ignore
    }
    window.location.reload()
  }, [])

  const contextMenuOptions = useMemo(
    () =>
      getLanguageContextMenuOptions(currentLanguage.value, onLanguageChange),
    [currentLanguage.value, onLanguageChange]
  )

  return (
    <ProfileMenuRow
      label={currentLanguage.label}
      actionLabel={t('navbar.userMenu.changeLanguage')}
      icon={
        <img
          className={styles.flag}
          src={currentLanguage.avatar}
          alt=''
          width={16}
          height={16}
        />
      }
      contextMenuProps={{
        options: contextMenuOptions
      }}
    />
  )
}

export { LanguageSection }
